import { standAloneSchedulerState } from '../standalone_scheduler/state_configuration';
import { FetchStudentActivePlanDetailsCommand } from '../search_and_add_courses/commands/fetch_student_active_plan_details_command';
import { IApplicationConfiguration } from '../interfaces/scheduler_interfaces';
import { FetchSchedulerAvailableTermsCommand } from '../scheduler_active_term/commands/fetch_scheduler_available_terms_command';
import { searchAndAddCourses } from '../search_and_add_courses/state_configuration';
import { ClearAllRegistrationSectionsCommand } from '../views/course_scheduler/commands/clear_all_registration_sections_command';
import { MarkSelectedFlagForScheduledSectionsCommand } from '../views/course_scheduler/commands/mark_selected_flag_for_scheduled_sections_command';
import { ICommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { AccountModel } from 'data-ng-authentication';
import { ScreenDeviceQuery } from 'screen-query';

import { SectionSwapServant } from '../swap/servants/section_swap_servant';
import { SectionSwapModel } from '../swap/models/course_section_swap_model';
import { ILoadCampusListCommand } from '../views/unscheduled_sections/commands/load_campus_list_command';
import { LoadProgramTermInfoCommand } from '../views/term_courses/commands/get_program_and_term_info_command';
const unscheduleCourseInfo = {
  url: 'course/:courseId/section_type/:sectionTypeId/',
  views: {
    'aside@my.schedule.registration': {
      template: '<unscheduled-sections></unscheduled-sections>',
      controller: ($timeout: ng.ITimeoutService, phxFocusDelegate: any) => {
        $timeout(() => {
          phxFocusDelegate.focus('schedule-section-rail');
        }, 500);
      }
    }
  },
  params: {
    sectionsFilter: 'available',
    sectionTypeId: '0'
  },
  onEnter: (
    getTermCoursesandScheduledSectionsCommand: ICommand,
    $stateParams: ng.ui.IStateParamsService,
    ngTermCoursesDatasource: any,
    getUnscheduledSectionsandAvailabilityCommand: ICommand,
    ngSectionSwapServant: SectionSwapServant,
    ngUnscheduledSectionsQuery: any
  ) => {
    ngUnscheduledSectionsQuery.clear();
    if (ngTermCoursesDatasource.size() === 0) {
      getTermCoursesandScheduledSectionsCommand($stateParams.termId);
    }

    const { sectionTypeId, courseId, termId } = $stateParams;

    // Need to update this, when in swap mode, dont get availability
    if (!$stateParams.ignoreConflicts) {
      getUnscheduledSectionsandAvailabilityCommand(termId, courseId, sectionTypeId);
    }
  },
  onExit: (clearSectionFiltersCommand: ICommand) => clearSectionFiltersCommand(),
  data: {
    activeTab: 'course_info',
    viewTitle: 'Schedule Course Information'
  }
};
export class SchedulerStateConfiguration {
  constructor(private $stateProvider: ng.ui.IStateProvider) {}
  /* tslint:disable:no-big-function */
  state(state: ng.ui.IState = {}) {
    this.$stateProvider
      .state(
        'my.schedule',
        _4.merge(
          {
            url: 'schedule/:termId/',
            template: '<ui-view/>',
            controller: ($state: ng.ui.IStateService, $stateParams: ng.ui.IStateParamsService) => {
              if ($state.current.name === 'my.schedule') {
                $state.go(
                  'my.schedule.registration',
                  { termId: $stateParams.termId },
                  {
                    location: 'replace'
                  }
                );
              }
            },
            sticky: true,
            data: {
              viewTitle: 'Scheduler'
            },
            resolve: {
              appConfigModel_: (
                appConfigModel: IApplicationConfiguration,
                $q: ng.IQService,
                loadAppConfigCommand: ICommand
              ) => {
                if (appConfigModel.isConfigLoaded()) {
                  return $q.resolve();
                }
                return loadAppConfigCommand();
              },
              schedulerConfig: (getSchedulerConfigCommand: ICommand) => getSchedulerConfigCommand()
            },
            onEnter: (
              pusherService: any,
              accountModel: AccountModel,
              appConfigModel: IApplicationConfiguration,
              fetchSchedulerAvailableTermsCommand: FetchSchedulerAvailableTermsCommand
            ) => {
              pusherService.startChannel(accountModel.username, {
                key: appConfigModel.getConfigProperty('PUSHER_KEY'),
                cluster: 'mt1'
              });
              fetchSchedulerAvailableTermsCommand();
            }
          },
          state['my.schedule']
        )
      )
      .state('my.schedule.transactions', {
        url: 'transactions/',
        template: '<registration-transactions></registration-transactions>',
        data: {
          viewTitle: 'Registration Transaction History'
        },
        resolve: {
          programTermInfo: (
            $stateParams: ng.ui.IStateParamsService,
            loadProgramTermInfoCommand: LoadProgramTermInfoCommand
          ) => loadProgramTermInfoCommand($stateParams.termId),
          _registrationActivity: (registrationActivityCommand: ICommand, $stateParams: ng.ui.IStateParamsService) =>
            registrationActivityCommand($stateParams.termId)
        }
      })
      .state(
        'my.schedule.registration',
        _4.merge(
          {
            url: 'registration/',
            views: {
              '': {
                template: `<scheduler-registration-container></scheduler-registration-container>`
              },
              'aside@my.schedule.registration': {
                template: '<term-info></term-info>'
              },
              'header@my.schedule.registration': {
                template: '<registration-header></registration-header>'
              },
              'calendar@my.schedule.registration': {
                template: '<scheduler-calendar></scheduler-calendar>'
              },
              'sections@my.schedule.registration': {
                template: `<scheduled-sections></scheduled-sections>
                  <phx-calendar-color-key-full></phx-calendar-color-key-full>`
              },
              'footer@my.schedule.registration': {
                template: `<registration-controls term-id="$ctrl.termId"></registration-controls>`
              }
            },
            resolve: {
              _termAndProgramInfo($stateParams: ng.ui.IStateParamsService, loadProgramTermInfoCommand: ICommand) {
                return loadProgramTermInfoCommand($stateParams.termId);
              },
              clearSelectedSections: (clearAllRegistrationSectionsCommand: ClearAllRegistrationSectionsCommand) =>
                clearAllRegistrationSectionsCommand(),
              _registrationActivity: (registrationActivityCommand: ICommand, $stateParams: ng.ui.IStateParamsService) =>
                registrationActivityCommand($stateParams.termId),
              campusList: (loadCampusListCommand: ILoadCampusListCommand) => loadCampusListCommand(),
              // combined call
              coursesAndScheduledSections: (
                getTermCoursesandScheduledSectionsCommand: ICommand,
                $stateParams: ng.ui.IStateParamsService,
                campusList: ng.IPromise<IQuery>,
                getSwapCommand: ICommand,
                loadTermLocationPreferencesCommand: any,
                ngPreferencesSelectionModel: any,
                ngTermScheduleFlags: any,
                clearSelectedSections: ng.IPromise<IQuery>,
                _termAndProgramInfo: ng.IPromise<IQuery>
              ) => {
                return getTermCoursesandScheduledSectionsCommand($stateParams.termId).then(() => {
                  return loadTermLocationPreferencesCommand($stateParams.termId);
                });
              },
              selectScheduledSectionsForRegistration: (
                coursesAndScheduledSections: ng.IPromise<IQuery>,
                markSelectedFlagForScheduledSectionsCommand: MarkSelectedFlagForScheduledSectionsCommand
              ) => markSelectedFlagForScheduledSectionsCommand(),
              studentPlans: (fetchStudentActivePlanDetailsCommand: FetchStudentActivePlanDetailsCommand) =>
                fetchStudentActivePlanDetailsCommand()
            },
            data: {
              viewTitle: 'Scheduler | Registration'
            },
            onEnter: function ($stateParams: ng.ui.IStateParamsService, ngScreenDeviceQuery: ScreenDeviceQuery) {
              // handler to remove intermediate uri from NEI history
              if (!ngScreenDeviceQuery.result.isScreenMobile) {
                return;
              }

              const navigationState = window['$ip'].di.inject('native-services', 'navigation_state');
              if (_4.isEmpty(navigationState)) {
                return;
              }

              const lastSavedUri = navigationState.history[navigationState.history.length - 1];
              if (
                lastSavedUri === '#/my/standalonescheduler/' ||
                lastSavedUri === `#/my/schedule/${$stateParams.termId}/`
              ) {
                navigationState.history.pop();
              }
            }
          },
          state['my.schedule.registration']
        )
      )
      .state('my.schedule.registration.preferences', {
        url: 'preferences/',
        resolve: {
          unavailability: (loadStudentUnavailabilityCommand: ICommand, $stateParams: ng.ui.IStateParamsService) =>
            loadStudentUnavailabilityCommand($stateParams.termId)
        },
        data: {
          viewTitle: 'Scheduler Preferences'
        },
        views: {
          'modal@my.schedule.registration': {
            template: '<schedule-preferences ng-hide="allCoursesSelected()"></schedule-preferences>'
          }
        }
      })
      .state(
        'my.schedule.registration.courseSections',
        _4.merge(unscheduleCourseInfo, state['my.schedule.registration.courseSections'])
      )
      .state('my.schedule.registration.swap', {
        url: 'swap/swap_course/:swapCourse',
        params: {
          courseId: -1
        },
        data: {
          viewTitle: 'Swap Course List'
        },
        views: {
          'header@my.schedule.registration': {
            template: '<registration-header></registration-header>'
          },
          'secondary-header@my.schedule.registration': {
            template: '<swap-header></swap-header>'
          },
          'sections@my.schedule.registration': {
            template: `<section-swap-preview></section-swap-preview>
                      <swap-confirmation-modal></swap-confirmation-modal>`
          },
          'calendar@my.schedule.registration': {
            template: '<scheduler-calendar mode="swap"></scheduler-calendar>'
          }
        },
        template: `<ui-view/>`
      })
      .state('my.schedule.registration.swap.courseSections', {
        ...unscheduleCourseInfo,
        url: '/course/:courseId/section_type/:sectionTypeId/ignore_conflicts/:ignoreConflicts',
        onEnter: (
          getUnscheduledSectionsandAvailabilityCommand: ICommand,
          $stateParams: ng.ui.IStateParamsService,
          ngSectionSwapServant: SectionSwapServant,
          ngCourseSectionSwapModel: SectionSwapModel
        ) => {
          getUnscheduledSectionsandAvailabilityCommand(
            $stateParams.termId,
            $stateParams.courseId,
            $stateParams.sectionTypeId,
            ngSectionSwapServant.getSwapFromIds(ngCourseSectionSwapModel),
            ngSectionSwapServant.getSwapToIds(ngCourseSectionSwapModel)
          );
        },
        data: {
          viewTitle: 'Swap Section'
        },
        views: {
          ...unscheduleCourseInfo.views,
          'header@my.schedule.registration': {
            template: '<registration-header></registration-header>'
          },
          'secondary-header@my.schedule.registration': {
            template: '<swap-header></swap-header>'
          },
          'calendar@my.schedule.registration': {
            template: '<scheduler-calendar mode="swap"></scheduler-calendar>'
          },
          'sections@my.schedule.registration': {
            template: `<section-swap-preview></section-swap-preview>
                      <swap-confirmation-modal></swap-confirmation-modal>`
          }
        }
      })
      .state('my.schedule.registration.swap.sectionTypeList', {
        url: '/course/:courseId/',
        data: {
          viewTitle: 'Swap Section Type List'
        },
        views: {
          'aside@my.schedule.registration': {
            template: `
            <div class="hide-print relative term-info" sibling-mediator>
              <multi-section-course-tile opened="true" ignore-full-status="true" course="getMultiSectionCourse()"></multi-section-course-tile>
            </div>
              `,
            controller: ($scope: ng.IScope, ngTermCourseQuery: IQuery, $stateParams: any) => {
              $scope.getMultiSectionCourse = () => {
                return _4.find(ngTermCourseQuery.result.planned, { id: parseInt($stateParams.courseId, 10) });
              };
            }
          },
          'header@my.schedule.registration': {
            template: '<registration-header></registration-header>'
          },
          'secondary-header@my.schedule.registration': {
            template: '<swap-header></swap-header>'
          },
          'calendar@my.schedule.registration': {
            template: '<scheduler-calendar mode="swap"></scheduler-calendar>'
          },
          'sections@my.schedule.registration': {
            template: `<section-swap-preview></section-swap-preview>
                      <swap-confirmation-modal></swap-confirmation-modal>`
          }
        }
      })
      .state('my.schedule.registration.reschedule.sections', {
        url: 'section_type/:sectionTypeId/ignore_conflicts/:ignoreConflicts',
        onEnter: (getUnscheduledSectionsandAvailabilityCommand: ICommand, $stateParams: ng.ui.IStateParamsService) => {
          getUnscheduledSectionsandAvailabilityCommand(
            $stateParams.termId,
            $stateParams.courseId,
            $stateParams.sectionTypeId
          );
        },
        params: {
          sectionTypeId: '0'
        },
        views: {
          'aside@my.schedule.registration': {
            template: '<unscheduled-sections></unscheduled-sections>'
          },
          'header@my.schedule.registration': {
            template: '<registration-header></registration-header>'
          },
          'calendar@my.schedule.registration': {
            template: '<scheduler-calendar></scheduler-calendar>'
          },
          'sections@my.schedule.registration': {
            template: `<scheduled-sections></scheduled-sections>
              <phx-calendar-color-key-full></phx-calendar-color-key-full>`
          },
          'footer@my.schedule.registration': {
            template: `<registration-controls term-id="$ctrl.termId"></registration-controls>`
          }
        }
      })
      .state('my.schedule.registration.reschedule', {
        url: 'reschedule/course/:courseId/',
        views: {
          'aside@my.schedule.registration': {
            template: `
            <div class="hide-print relative term-info" sibling-mediator>
              <multi-section-course-tile opened="true" is-rescheduling="true" ignore-full-status="true" course="getMultiSectionCourse()"></multi-section-course-tile>
            </div>
              `,
            controller: ($scope: ng.IScope, ngTermCourseQuery: IQuery, $stateParams: any) => {
              $scope.getMultiSectionCourse = () => {
                return _4.find(ngTermCourseQuery.result.planned, { id: _4.toNumber($stateParams.courseId) });
              };
            }
          },
          'header@my.schedule.registration': {
            template: '<registration-header></registration-header>'
          },
          'calendar@my.schedule.registration': {
            template: '<scheduler-calendar></scheduler-calendar>'
          },
          'sections@my.schedule.registration': {
            template: `<scheduled-sections></scheduled-sections>
              <phx-calendar-color-key-full></phx-calendar-color-key-full>`
          },
          'footer@my.schedule.registration': {
            template: '<registration-controls term-id="$ctrl.termId"></registration-controls>'
          }
        }
      })
      .state(
        'my.schedule.registration.search',
        _4.merge(
          {
            views: {
              'aside@my.schedule.registration': {
                template: '<crn-search></crn-search>'
              }
            },
            data: {
              viewTitle: 'Scheduler Class Search',
              preventResetFocus: true
            }
          },
          state['my.schedule.registration.search']
        )
      )
      .state('my.standalonescheduler', standAloneSchedulerState)
      .state('my.schedule.searchandaddcourses', searchAndAddCourses)
      .state('my.schedule.quickscheduler', {
        url: 'quickscheduler/',
        templateUrl: 'capability-ng-scheduler/src/views/course_scheduler/modals/suggestions/suggestions.html',
        controller: 'scheduleSuggestionsController',
        resolve: {
          programTermInfo: (
            $stateParams: ng.ui.IStateParamsService,
            loadProgramTermInfoCommand: LoadProgramTermInfoCommand
          ) => loadProgramTermInfoCommand($stateParams.termId),
          suggestions: ($stateParams: ng.ui.IStateParamsService, loadSuggestionsCommand: ICommand) =>
            loadSuggestionsCommand($stateParams.termId)
        }
      })
      .state(
        'my.schedule.registration.unselected',
        _4.merge(
          {
            url: 'unselected/',
            data: {
              viewTitle: 'Friendly Reminder'
            },
            templateUrl: 'capability-ng-scheduler/src/views/course_scheduler/modals/unselected/unselected.html',
            controller: 'scheduleUnselectedController'
          },
          state['my.schedule.registration.unselected']
        )
      )

      .state(
        'my.schedule.registration.remove_from_waitlist',
        _4.merge(
          {
            url: 'remove_from_waitlist/',
            data: {
              viewTitle: 'Remove From Waitlist'
            },
            templateUrl: 'capability-ng-scheduler/src/views/course_scheduler/modals/drop_course/drop_course.html',
            controller: 'scheduleDropCourseController'
          },
          state['my.schedule.registration.remove_from_waitlist']
        )
      )

      .state(
        'my.schedule.availability',
        _4.merge(
          {
            url: 'availability/',
            templateUrl:
              'capability-ng-scheduler/src/views/course_scheduler/modals/availability_preferences/availability_preferences.html',
            controller: 'schedulePreferencesController'
          },
          state['my.schedule.availability']
        )
      )
      .state('my.schedule.registration.sectionCoreqs', {
        abstract: true
      })
      .state('my.schedule.registration.withdraw', {
        url: 'withdraw/:sectionId',
        views: {
          'modal@my.schedule.registration': {
            template: '<withdraw-modal></withdraw-modal>'
          }
        }
      })
      .state(
        'my.schedule.registration.sectionCoreqs.sections',
        _4.merge(
          {
            ...unscheduleCourseInfo,
            data: {
              viewTitle: 'Section Corequisites'
            },
            views: {
              ...unscheduleCourseInfo.views,
              'header@my.schedule.registration': {
                template: '<registration-header></registration-header>'
              },
              'calendar@my.schedule.registration': {
                template: '<scheduler-calendar></scheduler-calendar>'
              },
              'sections@my.schedule.registration': {
                template: `<scheduled-sections></scheduled-sections>
              <phx-calendar-color-key-full></phx-calendar-color-key-full>`
              },
              'footer@my.schedule.registration': {
                template: `<registration-controls term-id="$ctrl.termId"></registration-controls>`
              }
            }
          },
          state['my.schedule.registration.sectionCoreqs.sections']
        )
      );
  }
  $get() {
    return {
      state: this.state
    };
  }
}

angular.module('capability-ng-scheduler').provider('schedulerStateConfiguration', SchedulerStateConfiguration);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/config/state_configuration.ts